/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_OverlineInputs */

const en_mk_faq_overline = /** @type {(inputs: Mk_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const id_mk_faq_overline = /** @type {(inputs: Mk_Faq_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Mk_Faq_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_overline = /** @type {((inputs?: Mk_Faq_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_overline(inputs)
	return en_mk_faq_overline(inputs)
});